/**
 * @author NikolaV
 */
import { latLonToEN } from '../ol-utils';
import { FeatureMouseInteraction } from '../interaction/FeatureMouseInteraction';
import Feature, { FeatureLike } from 'ol/Feature';
import { Point as OlPoint } from 'ol/geom';
import * as olStyle from 'ol/style';


let lastIndex = 1; // used to assign unique index to each feature when they are added
const FEATURE_TYPE = 'model_point';

const styleCache = {};

function styleFunction(feature: FeatureLike, labelProps: string[]) {
    if (!labelProps.length) {
        return null;
    }
    const point = feature.get('data');
    let color = '0,0,0';

    const labels = [];
    for (const labelProp of labelProps) {
        if (labelProp === 'x') labels.push(point.northing);
        else if (labelProp === 'y') labels.push(point.easting);
        else if (labelProp === 'z') labels.push(point.elevation);
        else if (labelProp === 'xyz') labels.push(`x: ${point.northing} y: ${point.easting} z: ${point.elevation}`);
        else if (labelProp === 'number') labels.push(point.pointNumber || '');
        else if (labelProp === 'surfacecode') labels.push(point.surfaceCode || '');
        else if (labelProp === 'code') labels.push(point.code || '');
        else if (labelProp === 'linecode') labels.push(point.props ? point.props.lineCode || '' : '');
        else if (labelProp === 'prop_name' && point.props) {
            labels.push(point.props.name ? point.props.name : point.props.pointName || '');
        }
    }

    const label = labels.join('\n');

    if (point.props?.color) {
        color = point.props.color;
    }

    const cacheKey = color + '_' + label;
    if (styleCache[cacheKey]) {
        return styleCache[cacheKey];
    }

    styleCache[cacheKey] = [ new olStyle.Style({
        text: label.length ? new olStyle.Text({
            text: label,
            overflow: true,
            font: '14px monospace',
            offsetY: 2,
            offsetX: 10,
            textAlign: 'left',
        }) : null
    })];

    return styleCache[cacheKey];
}

function makeFeature(point: IOutlinePoint, mouseInteraction?: FeatureMouseInteraction): Feature {
    const coord: Coordinate = latLonToEN(point.lat, point.lon);
    if (!coord) {
        console.warn('Skipping bad outline point: ', point);
        throw new Error();
    }

    const feature = new Feature({
        geometry: new OlPoint(coord)
    });

    const source: FeatureSource = {};
    if (point.sourceModelId) source.modelId = point.sourceModelId;
    if (point.filename) source.modelName = point.filename;

    feature.set('index', lastIndex++, true);
    feature.set('source', source, true);
    feature.set('data', point, true);
    feature.set('type', FEATURE_TYPE, true);
    feature.set('mouseInteraction', mouseInteraction, true);
    //feature.setId(null); can't have actual id (lots of non-id'd points) and id can't be null

    return feature;
}

export const GtPointFeatureFactory = {
    makeFeature,
    styleFunction,
    styleCache,
    FEATURE_TYPE,
};
